import React, { useState } from 'react'
import styled from 'styled-components'
import Section from '../../../common/Section/Section'
import Slider from './Slider'
 
const Wrap = styled.div`

`
 
const EveryWindowWeInstallSection = ({ data }) => {
  const [currPiece, setCurrPiece] = useState(0)
  const updateCurrPiece = (prevNext) => {
    return(
      prevNext === "prev"
        ? currPiece > 0
          ? setCurrPiece(currPiece - 1)
          : setCurrPiece(graphicDataClean.length - 1)
        : currPiece < (graphicDataClean.length - 1)
          ? setCurrPiece(currPiece + 1)
          : setCurrPiece(0)
    )
  }

  // console.log("every window data: ", data)
  const { richText1 } = data ? data : { data: null };

  const graphicDataRaw = []
  richText1 && richText1.json.content.map((piece, i) => {
    return (
      piece.nodeType === "embedded-entry-block"
        ? graphicDataRaw.push(piece.data.target.fields)
        : null
    )
  })
  // console.log("graphicDataRaw: ", graphicDataRaw)

  const graphicDataClean = []
  graphicDataRaw && graphicDataRaw.map((piece, i) => {
    const title = piece.title["en-US"];
    const copy = piece.copy["en-US"].content[0].content[0].value;
    const image = piece.image["en-US"].fields;
    const imageTitle = image.title["en-US"];
    const imageUrl = image.file["en-US"].url;
    return (
      graphicDataClean.push(
        {
          title: title,
          copy: copy,
          imageTitle: imageTitle,
          imageUrl: imageUrl
        }
      )
    )
  })
  // console.log("graphicDataClean: ", graphicDataClean)

  return (
    <Wrap> 
      <Section data={data} >
        <Slider data={graphicDataClean} currPiece={currPiece} updateCurrPiece={updateCurrPiece} />            
      </Section>
    </Wrap>
  )
}
 
export default EveryWindowWeInstallSection